/**
 * JobMatch NG Central WhatsApp Configuration
 * Official website customer-facing WhatsApp contact & click-to-chat configuration.
 */

export const WHATSAPP_CONTACT_NUMBER = '+1 555-491-7604';
export const WHATSAPP_CLEAN_NUMBER = '15554917604';
export const WHATSAPP_CHAT_URL = 'https://wa.me/15554917604';
export const WHATSAPP_DEFAULT_MESSAGE = 'Hello JobMatch NG! I need an artisan.';
export const WHATSAPP_WEBHOOK_URL = 'https://jobmatchng2-1.onrender.com/api/whatsapp/webhook';
export const WHATSAPP_VERIFY_TOKEN_DEFAULT = 'jobmatch_verify_token_secure_2026';
